export default __webpack_public_path__ + "static/media/beer-browser.64b0861e.png";